import React, { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { User } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const Managers: React.FC<{
  expanded: boolean
  data: User[]
  className: any
  img: any
  onExpand: () => void
}> = ({ className, img = [], expanded, data = [], onExpand = () => {} }): JSX.Element => {
  const classes = useStyles()

  const smDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  return (
    <Box className={classes.managers}>
      <Accordion id="managers" expanded={expanded} onChange={onExpand} square={false}>
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Менеджеры</AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            <Box mt={smDown ? 1 : 2}>
              {data.map((item: User, index: number) => {
                return (
                  <Box key={`managers${index}`} className={classes.name}>
                    {item.lastName} {item.firstName} {item.middleName}
                  </Box>
                )
              })}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  managers: {},
  name: {
    fontSize: 17,
    fontWeight: 500,
    transition: '0.2s',
    marginBottom: 15,
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 14,
      marginBottom: 8,
    },
  },
  icon: {},
}))
